module.exports = __webpack_public_path__ + "static/media/hands_yellow.28cc6e3c.jpg";